<template>
  <ul class="effect-list">
    <effect-item
      v-for="effect in effects"
      :key="effect.id"
      :effect="effect"
    />
  </ul>
</template>
<script>
import EffectItem from "./EffectItem";
export default {
  name: "EffectList",
  components: {
    EffectItem
  },
  computed: {
    effects() {
      return this.$store.getters.effects;
    }
  }
};
</script>
